<template>
  <b-modal
    ref="modal"
    title="Tag editor"
    centered
    @hide="closeHandler"
  >
    <template #modal-footer>
      <ButtonPrimary
        variant="primary"
        @click="accept"
      >
        Yes
      </ButtonPrimary>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        No
      </ButtonOutline>
    </template>

    <div class="c-tag-editor__body">
      <b-spinner v-if="isStockTagsLoading" />
      <select2
        v-else
        v-model="tags"
        :settings="{ multiple: true }"
        :options="stockTags"
      />
    </div>
  </b-modal>
</template>

<script>
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import select2 from 'v-select2-component'
import mixinModal from "./mixin"
import { createNamespacedHelpers } from 'vuex'
import Requests from "../../../../services/api/file-browser";

const { mapGetters, mapActions } = createNamespacedHelpers('fileBrowser')

export default {
  name: "TagsEditorModal",
  components: {ButtonOutline, ButtonPrimary, select2},
  mixins: [
    mixinModal
  ],
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    tags: []
  }),
  computed: {
    ...mapGetters(['stockTags', 'isStockTagsLoading']),
  },
  watch: {
    payload() {
      this.tags = this.payload?.tags || []
    }
  },
  methods: {
    ...mapActions(['fetchList']),
    async accept() {
      try {
        await Requests.storeStockTags({
          fileName: this.payload.name,
          tags: this.tags,
          url: this.payload.path.split('file=').pop(),
        })
        this.fetchList();
      } catch (error) {
        toastr.error('Something went wrong while saving tags')
      } finally {
        this.close();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.c-tag-editor__body > div {
  display: grid;

  ::v-deep .select2-selection__choice {
    padding-left: 19px!important;
  }
}
</style>